module.exports = __webpack_public_path__ + "static/media/default-message-background.f289e493.png";